import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listEspecialidades:[],
};
export const mutations = {
  GET_ESPECIALIDADES({ context }, listEspecialidad) {
    state.loading = false;
    if (listEspecialidad) {
      let especialidades = [];
      Object.entries(listEspecialidad).forEach(([key, val]) => especialidades.push(val));
      return (state.listEspecialidades = especialidades);
    }
  },
  SAVE_ESPECIALIDAD({ context }, especialidad) {
    state.newEspecialidad = Object.assign({}, especialidad);
  },
  EDIT_ESPECIALIDAD({ context }, data) {
    state.dataEspecialidad = Object.assign({}, data);
  },
};
export const actions = {
  GET_ESPECIALIDADES({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data.especialidades);
          commit("SET_LOADING", false);
          commit("GET_ESPECIALIDADES", response.data.data.especialidades);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_ESPECIALIDAD({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_ESPECIALIDAD", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_ESPECIALIDAD({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_ESPECIALIDAD", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_ESPECIALIDAD({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  };

export const getters = {//leer datos
  listEspecialidades: state => state.listEspecialidades,
  ListaEspecialidadesActivos: (state, getters, store) => {
    let listaEspecialidadesCompleta = getters.listEspecialidades;
    let listActivos = listaEspecialidadesCompleta.filter( function(especialidad) {
         return especialidad.deleted_at == null;
       });
    return listActivos;
  },
};
